import { assertNever } from '../../../common/helper';
import { PileId } from '../logic-types';

export class PileIdHandler {
  public static getStringFromPileId(pileId: PileId): string {
    switch (pileId) {
      case PileId.Foundation_01:
        return 'F1';
      case PileId.Foundation_02:
        return 'F2';
      case PileId.Foundation_03:
        return 'F3';
      case PileId.Foundation_04:
        return 'F4';
      case PileId.Tableau_01:
        return 'T1';
      case PileId.Tableau_02:
        return 'T2';
      case PileId.Tableau_03:
        return 'T3';
      case PileId.Tableau_04:
        return 'T4';
      case PileId.Tableau_05:
        return 'T5';
      case PileId.Tableau_06:
        return 'T6';
      case PileId.Tableau_07:
        return 'T7';
      case PileId.Deck:
        return 'D';
      case PileId.Waste:
        return 'W';
      default: {
        assertNever(pileId, 'Unknown pileId');
      }
    }
  }

  public static getPileIDFromString(id: string): PileId {
    switch (id) {
      case 'F1':
        return PileId.Foundation_01;
      case 'F2':
        return PileId.Foundation_02;
      case 'F3':
        return PileId.Foundation_03;
      case 'F4':
        return PileId.Foundation_04;
      case 'T1':
        return PileId.Tableau_01;
      case 'T2':
        return PileId.Tableau_02;
      case 'T3':
        return PileId.Tableau_03;
      case 'T4':
        return PileId.Tableau_04;
      case 'T5':
        return PileId.Tableau_05;
      case 'T6':
        return PileId.Tableau_06;
      case 'T7':
        return PileId.Tableau_07;
      case 'W':
        return PileId.Waste;
      case 'D':
        return PileId.Deck;
      default:
        throw new Error(`Unknown pile id: ${id}`);
    }
  }
}
